import { NavItem } from '../../vertical/sidebar/nav-item/nav-item';

/**
 * Items du menu horizontal (vue compacte / top-bar).
 *
 * <p>Conserve uniquement les entrées de premier niveau ; pour le menu
 * complet (verticale), voir {@code vertical/sidebar/sidebar-data.ts}.</p>
 *
 * <p>Les rôles utilisés ici sont alignés avec
 * {@code auth.service.ts > UserType}.</p>
 */
export const navItems: NavItem[] = [
  // ─── BUSINESS / ADMIN ───────────────────────────────────────────────
  {
    displayName: 'Tableau de bord',
    iconName: 'solar:home-smile-line-duotone',
    route: '/dinki/dashboard',
    roles: ['ADMIN', 'BUSINESS', 'CUSTOMER'],
  },
  {
    displayName: 'Clients',
    iconName: 'solar:users-group-two-rounded-line-duotone',
    route: '/dinki/clients',
    roles: ['BUSINESS'],
  },
  {
    displayName: 'Mesures',
    iconName: 'solar:ruler-line-duotone',
    route: '/dinki/mesures',
    roles: ['BUSINESS'],
  },
  {
    displayName: 'Modèles',
    iconName: 'solar:palette-line-duotone',
    route: '/dinki/modeles',
    roles: ['BUSINESS'],
  },
  {
    displayName: 'Commandes',
    iconName: 'solar:bag-3-line-duotone',
    route: '/dinki/commandes',
    roles: ['BUSINESS'],
  },
  {
    displayName: 'Board',
    iconName: 'solar:checklist-line-duotone',
    route: '/dinki/commandes/board',
    roles: ['BUSINESS'],
  },
  {
    displayName: 'Finances',
    iconName: 'solar:wallet-line-duotone',
    route: '/dinki/finances',
    roles: ['ADMIN', 'BUSINESS'],
  },
  {
    displayName: 'Mon Atelier',
    iconName: 'solar:shop-line-duotone',
    route: '/dinki/atelier',
    roles: ['BUSINESS'],
  },
  {
    displayName: 'Administration',
    iconName: 'solar:shield-user-line-duotone',
    route: '/dinki/admin/overview',
    roles: ['ADMIN'],
  },

  // ─── CUSTOMER ───────────────────────────────────────────────────────
  {
    displayName: 'Mes mesures',
    iconName: 'solar:ruler-line-duotone',
    route: '/dinki/mes-mesures',
    roles: ['CUSTOMER'],
  },
  {
    displayName: 'Mes commandes',
    iconName: 'solar:bag-3-line-duotone',
    route: '/dinki/mes-commandes',
    roles: ['CUSTOMER'],
  },

  // ─── PARTNER ────────────────────────────────────────────────────────
  {
    displayName: 'Partenariat',
    iconName: 'solar:hand-shake-line-duotone',
    route: '/dinki/partenariat',
    roles: ['PARTNER'],
  },
];
